












import { accountsProvider } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib';
import Proxyable from '@/mixins/proxyable';

export default Proxyable.extend({
  name: 'AccountPicker',

  props: {
    outlined: { type: Boolean, default: true }
  },

  computed: {
    accountsProvider(): any {
      return accountsProvider(this.$store);
    },

    accounts(): any {
      return this.accountsProvider.getDataTableAccounts;
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.accountsProvider.fetchAccounts();
    }
  }
});
